import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Headers, Response } from '@angular/http';
import { environment } from '../../environments/environment';

declare const fbq;

@Injectable()
export class FacebookPixelEventTrackerService {

  constructor(private http: Http) { }

  public trackEvent(properties: Object) {

    if (typeof fbq === 'undefined') {
      return;
    }
    fbq('track', 'CompleteRegistration');
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/facebookpixeleventtracker.service.ts